module.exports = __webpack_public_path__ + "static/media/arcdev3-estimate.56558c2b.PNG";